module.exports = __webpack_public_path__ + "img/Loop.33e9d0e6.gif";